import {RemotePostFavoriteDoctor} from 'data/usecases';
import {PostFavoriteDoctor} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makePostFavoriteDoctor = (): PostFavoriteDoctor =>
  new RemotePostFavoriteDoctor(
    makeBFFApiUrl(GuideFlowEndpoints.medicalFavoriteDoctors),
    makeAuthorizeHttpClientDecorator(),
  );
